import React from "react";
import { Card } from "@material-ui/core";

import WorkTab from "../../containers/WorkTab/WorkTab";

const tabList = [
  {
    key: "scientificResearch",
    title: "Bài báo",
  },
  {
    key: "solution",
    title: "Giải pháp hữu ích",
  },
  {
    key: "patent",
    title: "Bằng sáng chế",
  },
  {
    key: "project",
    title: "Đề tài nghiên cứu",
  },
  {
    key: "monograph",
    title: "Sách/Chương sách",
  },
  {
    key: "exhibition",
    title: "Triển lãm",
  },
  {
    key: "achievement",
    title: "Giải thưởng",
  },
  {
    key: "studentGuidance",
    title: "Hướng dẫn SV NCKH",
  },
  {
    key: "scientificCouncilNew",
    title: "Hội đồng khoa học",
  },
];

function Work() {
  return (
    <Card style={{ minHeight: "calc(100vh - 92px)", position: "relative" }}>
      <WorkTab tabList={tabList} address={window.location.href} />
    </Card>
  );
}

export default Work;

